import { Button, Checkbox, Form, Input, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Loader, Modal, Result404 } from 'components';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { UsersWithWithdrawFilterFormField } from 'features/withdraw/components/users-with-wallet-filter-form/type';
import { useCreateSuperAdminManual } from 'features/withdraw/use-cases/create-admin-manual';
import { useGetWithdrawTransactionDetails } from 'features/withdraw/use-cases/get-withdraw-details';
// ../users-with-wallet-filter-form/type
export const WithdrawViewModalManual = ({
  onClose,
  id,
  onSuccess,
}: {
  onClose: () => void;
  id: string;
  onSuccess: any;
}) => {
  // const { t } = useTranslation();
  const userQueryResult: any = useGetWithdrawTransactionDetails(`id=${id}`, {
    cacheTime: 0,
  });
  const [form] = Form.useForm();
  const {
    isLoading: isLoadingGetSocial,
    isFetching: isFetchingGetSocial,
    data: withdrawdata,
    isError: isErrorLabel,
  } = userQueryResult;
  const isLoading = {
    loading: isLoadingGetSocial || isFetchingGetSocial,
    isLoadingGetSocial,
  };

  const { mutate: mutateUpdateManual, isLoading: mutateLoad } =
    useCreateSuperAdminManual();
  const handleSubmit = (formdata: any) => {
    const dataToSubmit = {
      id, // assuming id is defined in the scope
      session_id: withdrawdata?.items[0].session_id,
      ottu_order_no: withdrawdata?.items[0]?.ottu_order_no,
      booking_id: withdrawdata?.items[0]?.booking_id,
      refund_amount: withdrawdata?.items[0]?.amount,
      user_name: withdrawdata?.items[0].user_name,
      phone_number: withdrawdata?.items[0].phone_number,
      status_id: 4,
      isForce: true,
      ...formdata,
    };
    mutateUpdateManual(dataToSubmit, { onSuccess });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        className='modal_social right-modal mtch_dtls_modal'
        open
        centered
        title={'Manual Refund Request'}
        onCancel={() => {
          document.body.style.overflow = 'none';
          onClose();
        }}
        getContainer={false}
        onOk={form.submit}
        footer={null}
        // okText={t('social.update.updatescore')}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        {isLoadingGetSocial ? (
          <Loader />
        ) : isErrorLabel ? (
          <Result404 />
        ) : (
          <Spin spinning={isLoading.loading}>
            <Form form={form} onFinish={handleSubmit}>
              <div className='wd_dta_modal'>
                <div className='wd_user'>
                  <p>
                    <span>User Name:</span>
                    <span>{withdrawdata?.items[0].user_name}</span>
                  </p>
                  <p>
                    <span>Phone Number:</span>
                    <span>{withdrawdata?.items[0].phone_number}</span>
                  </p>
                  <p>
                    <span>Request Amount:</span>
                    <span>{withdrawdata?.items[0].amount} KD</span>
                  </p>
                </div>
                <div className='frm_dta'>
                  <Form.Item
                    label='Reference Number'
                    name={UsersWithWithdrawFilterFormField.ReferenceNumber}
                  >
                    <Input placeholder='Enter a Reference Number' />
                  </Form.Item>

                  <Form.Item
                    label='Remark'
                    name={UsersWithWithdrawFilterFormField.Remark}
                  >
                    <TextArea rows={5} />
                  </Form.Item>

                  <Form.Item
                    name='manualRefund'
                    valuePropName='checked'
                    rules={[
                      {
                        required: true,
                        message: 'Please confirm manual refund',
                      },
                    ]}
                  >
                    <Checkbox
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      Are you sure you want to proceed with a manual refund?
                    </Checkbox>
                  </Form.Item>
                </div>

                <div className='btn_grp'>
                  <Button
                    className='btn'
                    htmlType='submit'
                    loading={mutateLoad}
                  >
                    Approve
                  </Button>
                  <Button className='btn' onClick={onClose}>
                    Cancel
                  </Button>
                </div>
              </div>
            </Form>
          </Spin>
        )}
      </Modal>
    </StyledUserModalWrapper>
  );
};
